import React, { useState } from 'react';

function MyForm() {
  const [name, setName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [whatsappUpdates, setWhatsappUpdates] = useState(false);
  const [contactViaWhatsapp, setContactViaWhatsapp] = useState(false); // New state for WhatsApp contact
  const [showPopup, setShowPopup] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    const formData = {
      name: name,
      phoneNumber: phoneNumber,
      whatsappUpdates: whatsappUpdates,
      contactViaWhatsapp: contactViaWhatsapp,
    };

    try {
      const response = await fetch("https://formspree.io/f/xovlvpjv", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        console.log("Form submitted successfully!");
        setShowPopup(true);

        // Send WhatsApp message if the checkbox is checked
        if (contactViaWhatsapp) {
          const whatsappMessage = `Name: ${name} \n Phone Number: ${phoneNumber}`;
          const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
          const whatsappUrl = isMobile 
            ? `whatsapp://send?phone=917701885426&text=${whatsappMessage}` 
            : `https://web.whatsapp.com/send?phone=917701885426&text=${whatsappMessage}`;
          
          window.open(whatsappUrl, '_blank');
        }

        setTimeout(() => {
          setShowPopup(false);
        }, 2000);

        setName('');
        setPhoneNumber('');
        setWhatsappUpdates(false);
        setContactViaWhatsapp(false);
      } else {
        const errorData = await response.json();
        console.error("Form submission failed:", errorData);
        alert("There was an error submitting your form. Please try again.");
      }
    } catch (error) {
      console.error("Network error during form submission:", error);
      alert("Network error. Please check your internet connection and try again.");
    }
  };

  return (
    <>
      <div className="card shadow-lg" style={{ background:"#ededede6", marginLeft: "auto", marginRight: "auto", width: '100%', maxWidth: '400px', borderRadius: '15px', padding: '20px' }}>
        <div className="card-body">
          <h2 className="mb-4 h3">Designs for Every Budget</h2>

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>

            <div className="mb-3">
              <div className="input-group">
                <span className="input-group-text">
                  🇮🇳
                </span>
                <input
                  type="tel"
                  className="form-control"
                  placeholder="Phone number"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="mb-3 form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id="whatsappUpdatesCheckbox"
                checked={whatsappUpdates}
                onChange={(e) => setWhatsappUpdates(e.target.checked)}
              />
              <label className="form-check-label" htmlFor="whatsappUpdatesCheckbox">
                Send me updates on WhatsApp
              </label>
            </div>

            {/* <div className="mb-3 form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id="contactViaWhatsappCheckbox"
                checked={contactViaWhatsapp}
                onChange={(e) => setContactViaWhatsapp(e.target.checked)}
              />
              <label className="form-check-label" htmlFor="contactViaWhatsappCheckbox">
                Contact me via WhatsApp
              </label>
            </div> */}

            <button
              type="submit"
              className="btn btn-danger w-100 mt-4"
              style={{ backgroundColor: '#FF4757', borderColor: '#FF4757' }}
            >
              Submit
            </button>
          </form>

          <p className="text-center text-muted small mt-3">
            By submitting this form, you agree to the <a href="#privacy" className="text-decoration-none text-danger">privacy policy</a> & <a href="#terms" className="text-decoration-none text-danger">terms and conditions</a>
          </p>
        </div>
      </div>

      {showPopup && (
        <div
          className="alert alert-success alert-dismissible fade show text-center"
          role="alert"
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 1050,
            minWidth: '250px',
            backgroundColor: '#d4edda',
            borderColor: '#c3e6cb',
            color: '#155724',
          }}
        >
          <strong>Thank You!</strong> Your submission has been received.
        </div>
      )}
    </>
  );
}

export default MyForm;